export default __webpack_public_path__ + "img/e4b2aec6b44f11b8366b8b34a7bd7964.svg";